import React from 'react'
import Modal from 'react-modal'

import AddItemToCollectionContainer from './collection/collectionLoadableContainer'
import AddItemToCartContainer from './cart/cartLoadableContainer'
import SignInContainer from './user/signInLoadableContainer'
import SignUpContainer from './signup/signUpLoadableContainer'
import GetFeedbackContainer from './user/getFeedbackLoadableContainer'

export default ({
  isModalOpen,
  closeModal,
  openModal,
  openModalType,
  openModalData
}) => {
  const renderModalContent = () => {
    switch (openModalType) {
      case 'addItemToCollection':
        return (
          <AddItemToCollectionContainer
            openModalData={openModalData}
            closeModal={closeModal}
          />
        )

      case 'addItemToCart':
        return <AddItemToCartContainer openModalData={openModalData} />

      case 'signIn':
        return (
          <SignInContainer
            openModal={openModal}
            closeModal={closeModal}
            openModalData={openModalData}
          />
        )

      case 'signUp':
        return <SignUpContainer closeModal={closeModal} />

      case 'getFeedback':
        return (
          <GetFeedbackContainer
            closeModal={closeModal}
            openModalData={openModalData}
          />
        )

      default:
        return null
    }
  }

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Modal"
      className="ReactModal__Content"
      overlayClassName="ReactModal__Overlay"
    >
      {renderModalContent()}
    </Modal>
  )
}
